module.exports = __webpack_public_path__ + "static/img/5.733987f6.png";